import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import StructuredData from '@/components/base/StructuredData';
import HeroSection from './components/HeroSection';
import BrandSection from './components/BrandSection';
import HotGridSection from './components/HotGridSection';
import FeatureNavSection from './components/FeatureNavSection';
import DailySection from './components/DailySection';
import CTASection from './components/CTASection';
import NewsletterSection from './components/NewsletterSection';

export default function Home() {
  return (
    <>
      <StructuredData type="home" />
      <Navbar />
      <main>
        <HeroSection />
        <BrandSection />
        <HotGridSection />
        <FeatureNavSection />
        <DailySection />
        <CTASection />
        <NewsletterSection />
      </main>
      <Footer />
    </>
  );
}